// External Dependencies
import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

// Local Typings
interface OverlayProps {
  variant?: 'disabled' | 'scrim';
}
interface WrapperProps {
  disabled: boolean;
  fullHeight?: boolean;
}

// Local Variables
const Wrapper = styled.div<WrapperProps>(props => ({
  height: props.fullHeight ? '100%' : undefined,
  pointerEvents: props.disabled ? 'none' : undefined,
  position: props.disabled ? 'relative' : 'static',
  width: '100%',
}));
const DisabledOverlay = styled.div<OverlayProps>(({
  theme,
  variant = 'disabled',
}) => ({
  backgroundColor: variant === 'disabled'
    ? theme.semanticColors.disabled_overlay
    : theme.semanticColors.scrim_overlay,
  bottom: 0,
  left: 0,
  opacity: 0.8,
  position: 'absolute',
  right: 0,
  top: 0,
}));

// Component Definition
const DisabledContainer: FC<PropsWithChildren<OverlayProps & WrapperProps>> = props => {
  return (
    <Wrapper
      disabled={props.disabled}
      fullHeight={props.fullHeight}
    >
      {props.children}
      {props.disabled && <DisabledOverlay variant={props.variant} />}
    </Wrapper>
  );
};

export default DisabledContainer;
